import {AutocompleteDropDownModel} from "../common/models/autocompleteDropdown";

export class AutocompleteDropDownUtils {
    public static listToAutocompleteDropDownMap(list: any[], id = "id", label = "label", renderOption = "renderOption"): AutocompleteDropDownModel[] {
        if (!list || (list && typeof list.map !== "function")) {
            return [];
        }

        return list.map((item) => ({id: item[id], label: item[label], renderOption: item[renderOption]}));
    }
}
